import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';
import {RefModelStoreService, SnackBarService, getInitials} from '@q9elements/ui-kit/common';
import {forkJoin, throwError} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';

import {Message} from '../../models/message.interface';
import {AiChatMarkdownService} from '../../services/ai-chat-markdown.service';
import {AiChatService} from '../../services/ai-chat.service';

@Component({
  selector: 'ai-chat-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageComponent {
  readonly assistantName = this.aiChatService.assistantName;
  @Input() message: Message;

  readonly user = this.rmeStore.user;
  readonly getInitials = getInitials;

  constructor(
    private rmeStore: RefModelStoreService,
    private snackBarService: SnackBarService,
    private aiChatService: AiChatService,
    private markdownService: AiChatMarkdownService
  ) {}

  textToHtml(markdown: string) {
    return this.markdownService.markdownToHtml(markdown);
  }

  private downloadFile(fileId: string) {
    const getFileContent$ = this.aiChatService.getFileContent(fileId).pipe(
      take(1),
      map(blob => URL.createObjectURL(blob)),
      catchError(async response => {
        const blobError = response.error as Blob;
        const result = await blobError.text().then(JSON.parse);

        return throwError(() => result.error);
      })
    );
    const getFileMetadata$ = this.aiChatService.getFileMetadata(fileId).pipe(
      take(1),
      map(({filename}) => filename.split('/').pop())
    );

    forkJoin({
      url: getFileContent$,
      filename: getFileMetadata$
    }).subscribe({
      next: ({url, filename}) => {
        if (!url || !filename) {
          return void 0;
        }

        const link = document.createElement('a');

        link.href = url.toString();
        link.download = filename;
        link.click();
      },
      error: error => {
        this.snackBarService.error(error);
      }
    });
  }
}
